import React, { useEffect, useState } from 'react';
import { wsGet } from 'services/WService';

export default function Pdf(props) {
  const [pdfUrl, setPdfUrl] = useState(true);
  const { showNotify, purchase } = props;

  useEffect(() => {
    if(purchase.pdf_path === null){
      showNotify('La compra no tiene pdf', 'warning');
      setPdfUrl(false);
      return;
    }

    wsGet(`purch/purchase/${purchase.id}/pdf`).then(response => setPdfUrl(response.data));
  }, [purchase]);

  const loadPDF =
    pdfUrl === true ? (
      <h3>Cargando...</h3>
    ) : pdfUrl === false ? (
      <h3>La compra no tiene pdf</h3>
    ): (
      <iframe src={pdfUrl} height="1200" width="100%"/>
    );

  return loadPDF;
}
